import React from 'react';
import PropTypes from 'prop-types';

// Layout
import { Layout } from './../components/Layout';

// Fields
import { SEO } from './../components/Seo';
import Headings from './../components/Headings';
import { DrawingsTable } from './../components/DrawingsTable';

import './../global/drawingspage.scss';

const DrawingsAndWinners = props => {

    const title = 'Drawings & Winners';
    const styleVariant = 'orange';
    return (
        <Layout
            styleVariant={styleVariant}
        >
            <SEO title={title} />
            <div className="title-content">
                <Headings>{title}</Headings>
            </div>
            <div className="white-content">
                <div className="main">
                    <main className="drawings">
                        <div className="info">
                            <p>
                                The Georgia Lottery will contact the winner(s) by phone and/or email.
                                An affidavit and a claim form will be required for the winner(s) of the
                                $10,000 monthly prizes and final prize of $10,000 a Month for Life.
                            </p>
                            <p>
                                Following the drawing and verification, and after the
                                winner(s) have been contacted, the winners names (first
                                and last initial) along with their city will be posted.
                            </p>
                        </div>

                        <DrawingsTable />
                    </main>
                </div>
            </div>
        </Layout>
    );
};

DrawingsAndWinners.propTypes = {
    props: PropTypes.object,
};

export default DrawingsAndWinners;
